import { IFacetGroupFilter } from 'Types/Litium';

const getFiltrationValuesAndUpdateUrlQuery = (
    facetGroups: IFacetGroupFilter[],
    data: FormData,
    removeSingle?: {
        name: string;
        value: string;
    }
) => {
    // Filter values
    const values = Array.from(data).map(filterValue => ({
        name: filterValue[0],
        value: filterValue[1] as string,
    }));

    const getCurrentParams = new URLSearchParams(window.location.search);
    // Page query param should not be kept as pages can be different when filtration is changed
    getCurrentParams.delete('page');

    const currentParams = Array.from(getCurrentParams).map(filterValue => ({
        name: filterValue[0],
        value: filterValue[1],
    }));

    const currentParamsWithoutFilterGroups = currentParams.filter(
        currentParam =>
            !facetGroups.find(param => param.id === currentParam.name)
    );

    const filterAndCurrentParams = [
        ...(removeSingle
            ? currentParams.filter(
                  param =>
                      !(
                          param.value === removeSingle.value &&
                          param.name === removeSingle.name
                      )
              )
            : values),
        ...currentParamsWithoutFilterGroups,
    ].filter(
        (item, index, self) =>
            index ===
            self.findIndex(t => t.name === item.name && t.value === item.value)
    );
    const urlWithoutQueryString =
        window.location.origin + window.location.pathname;

    window.history.replaceState(
        {},
        '',
        `${urlWithoutQueryString}?${encodeURI(
            filterAndCurrentParams
                .map(facet => `${facet.name}=${facet.value}`)
                .join('&')
        )}`
    );

    return filterAndCurrentParams;
};

export default getFiltrationValuesAndUpdateUrlQuery;
